import "./StatusOfferForm.scss"

import {
  AGENT_STATUS_CONTRACT,
  AGENT_STATUS_OFFER,
  ANSWER_TYPE,
  OFFER_STATUS_ACCEPTED,
  OFFER_STATUS_REJECTED,
  QUESTION_TYPE
} from 'common/constants'
import {connect} from 'react-redux'
import {createStructuredSelector} from 'reselect'
import {OfferStatusField} from 'manager/views/components/ReferralStatus/OfferStatusChoices'
import {NoteField} from 'manager/views/components/ReferralStatus/NoteField'
import {saveStatus} from 'manager/redux/referral_status'
import {
  selectHasTourInfoOrValidNote,
  selectNote,
  selectOfferStatus,
  selectOfferStatusValid,
  selectSettlement,
  selectSettlementNewSelectionCompany
} from 'manager/selectors/referral_status_selectors'
import {
  selectIsPropertyInquiryTourUpdateNeeded,
  selectReferralQualiaAskAgentQuestion,
  selectReferralQualiaEnabled,
  selectTitleDoYouKnowProviderQuestion,
  selectTitleWhoIsProviderQuestion,
  selectTitleWillYouSelectQuestion,
  selectTransactionType,
} from 'manager/selectors/referral_selectors'
import {StatusSubmitButton} from 'manager/views/components/ReferralStatus/StatusSubmitButton'
import {withRouter} from 'react-router'
import FeedbackCheckbox from 'common/views/components/FeedbackCheckbox'
import PropertyTourQuestions from 'manager/views/components/ReferralStatus/PropertyTourQuestions'
import React, {Component} from 'react'
import ReferralQualiaQuestions from "manager/views/components/ReferralStatus/ReferralQualiaQuestions"

class OfferForm extends Component {
  state = {
    doContract: false,
    optedOut: false
  }

  shouldDoContract = () => this.props.offerStatus === OFFER_STATUS_ACCEPTED && this.state.doContract

  onSubmit = () => {
    const {
      saveStatus,
      note,
      offerStatus,
      newSelectionCompany,
      selectSettlement,
      titleWillYouSelectAnswer,
      titleDoYouKnowProviderAnswer,
      titleWhoIsProviderAnswer,
      shouldAskAgentQuestion
    } = this.props

    const nextSteps = this.shouldDoContract() ? {nextStatus: AGENT_STATUS_CONTRACT} : {}

    let payload = {
      note,
      offer_status: offerStatus,
    }

    if (shouldAskAgentQuestion && offerStatus !== OFFER_STATUS_REJECTED) {
      let settlement_new_selection_company = null
      let title_questions = {[QUESTION_TYPE.TITLE_WILL_YOU_SELECT]: titleWillYouSelectAnswer}

      if (titleWillYouSelectAnswer && titleWillYouSelectAnswer[ANSWER_TYPE.YES_NO] === 'yes') {

        if (titleDoYouKnowProviderAnswer) {
          title_questions[QUESTION_TYPE.TITLE_DO_YOU_KNOW_PROVIDER] = titleDoYouKnowProviderAnswer

          if (titleDoYouKnowProviderAnswer && titleDoYouKnowProviderAnswer[ANSWER_TYPE.YES_NO] === 'yes') {
            title_questions[QUESTION_TYPE.TITLE_WHO_IS_PROVIDER] = titleWhoIsProviderAnswer

            if (titleWhoIsProviderAnswer) {
              settlement_new_selection_company = newSelectionCompany
            }
          }
        }
      }

      payload.title_questions = title_questions
      payload.settlement = selectSettlement
      payload.settlement_new_selection_company = settlement_new_selection_company
    }

    saveStatus({
      action: 'update',
      status: AGENT_STATUS_OFFER,
      payload: payload,
      ...nextSteps,
    })
  }

  render() {
    const {
      hasTourInfoOrValidNote,
      isOfferStatusValid,
      isReferralQualiaEnabled,
      isTourUpdateNeeded,
      offerStatus,
      transactionType,
      titleWillYouSelectAnswer,
      titleDoYouKnowProviderAnswer,
      titleWhoIsProviderAnswer,
      shouldAskAgentQuestion,
    } = this.props

    const {doContract} = this.state

    const titleWillYouSelectAnswerNo = titleWillYouSelectAnswer && titleWillYouSelectAnswer[ANSWER_TYPE.YES_NO] !== 'yes'
    const titleDoYouKnowProviderAnswerNo = titleDoYouKnowProviderAnswer && titleDoYouKnowProviderAnswer[ANSWER_TYPE.YES_NO] === 'no'
    const validTitleQuestions = titleWillYouSelectAnswer && (!isReferralQualiaEnabled || titleWillYouSelectAnswerNo || (titleDoYouKnowProviderAnswer && (titleDoYouKnowProviderAnswerNo || titleWhoIsProviderAnswer)))
    const shouldValidateQuestions = shouldAskAgentQuestion && offerStatus !== OFFER_STATUS_REJECTED

    const isValid = hasTourInfoOrValidNote && isOfferStatusValid && (!shouldValidateQuestions || validTitleQuestions)

    const showContractCheckbox = (
      transactionType !== 'lease' &&
      offerStatus === OFFER_STATUS_ACCEPTED
    )

    return (
      <div className="StatusOfferForm">
        <div className="ReferralStatusForm__body">
          { isTourUpdateNeeded && <PropertyTourQuestions />}
          <NoteField />
          <OfferStatusField />
          {offerStatus !== OFFER_STATUS_REJECTED && <ReferralQualiaQuestions editStatus={AGENT_STATUS_OFFER}/>}

          {showContractCheckbox && (
            <div className="StatusOfferForm__details_check">
              <FeedbackCheckbox
                label="Enter contract details now"
                checked={doContract}
                onChange={() => this.setState(({ doContract }) => ({ doContract: !doContract }))} />
            </div>
          )}
        </div>
        <div className="ReferralStatusForm__footer">
          <StatusSubmitButton
            disabled={!isValid}
            onClick={this.onSubmit}>
            {this.shouldDoContract() ? 'Update & move to contract' : 'Update status'}
          </StatusSubmitButton>
        </div>
      </div>
    )
  }
}

const selector = createStructuredSelector({
  hasTourInfoOrValidNote: selectHasTourInfoOrValidNote,
  isOfferStatusValid: selectOfferStatusValid,
  isTourUpdateNeeded: selectIsPropertyInquiryTourUpdateNeeded,
  note: selectNote,
  offerStatus: selectOfferStatus,
  transactionType: selectTransactionType,
  newSelectionCompany: selectSettlementNewSelectionCompany,
  selectSettlement: selectSettlement,
  titleWillYouSelectAnswer: selectTitleWillYouSelectQuestion,
  titleDoYouKnowProviderAnswer: selectTitleDoYouKnowProviderQuestion,
  titleWhoIsProviderAnswer: selectTitleWhoIsProviderQuestion,
  shouldAskAgentQuestion: selectReferralQualiaAskAgentQuestion,
  isReferralQualiaEnabled: selectReferralQualiaEnabled,
})

const actions = {
  saveStatus,
}

const withRedux = connect(selector, actions)

export const StatusOfferForm = withRedux(withRouter(OfferForm))
